import type { DataCollector } from 'owa-diagnostics-data-collection';
import loc from 'owa-localize';
import { lazyRegisterDataCollectorIfNotRegistered } from 'owa-diagnostics-data-collection';
import { errorCodesDataCollectorDescription } from './registerSharedDataCollectors.locstring.json';
import { getEncounteredErrorCodes } from 'owa-error-codes';

export async function registerSharedDataCollectors(): Promise<void> {
    const errorCodesDataCollector: DataCollector = {
        name: 'ErrorCodes',
        odsFileDescription: 'All Error Codes from the sesssion',
        description: loc(errorCodesDataCollectorDescription),
        dataCollectionAction: () => {
            return Promise.resolve(JSON.stringify(getEncounteredErrorCodes()));
        },
    };

    await lazyRegisterDataCollectorIfNotRegistered.importAndExecute(errorCodesDataCollector);
}
